/**
 * kqxs-live.js
 *
 * Trang KQXS Live — /ket-qua-xo-so/live/
 *
 * Tính năng:
 *  1. Auto-refresh toàn trang mỗi 30 giây khi đang trong khung giờ live (16:00–20:00)
 *  2. Nút "Refresh ngay" để load lại ngay lập tức
 *  3. Cập nhật trạng thái badge (waiting / opening / completed) theo giờ hiện tại
 *  4. Hiển thị countdown đến lần refresh tiếp theo
 *  5. Tự động ẩn overlay theo giờ:
 *       southern-lottery__overlay → ẩn sau 16:10
 *       central-lottery__overlay  → ẩn sau 17:10
 *       northern-lottery__overlay → ẩn sau 18:10
 */

(function () {
  'use strict';

  const LIVE_START = 16; // 16:00
  const LIVE_END   = 20; // 20:00
  const REFRESH_INTERVAL_S = 30; // giây

  /**
   * Lịch ẩn overlay: { selector, hideHour, hideMin }
   */
  const OVERLAY_SCHEDULE = [
    { selector: '.southern-lottery__overlay', hideHour: 16, hideMin: 10 },
    { selector: '.central-lottery__overlay',  hideHour: 17, hideMin: 10 },
    { selector: '.northern-lottery__overlay', hideHour: 18, hideMin: 10 },
  ];

  /**
   * Kiểm tra xem overlay có nên bị ẩn tại thời điểm hiện tại không.
   */
  function shouldHideOverlay(hideHour, hideMin) {
    const d = new Date();
    const h = d.getHours(), m = d.getMinutes();
    return ( h > hideHour ) || ( h === hideHour && m >= hideMin );
  }

  /**
   * Ẩn một overlay element với transition.
   */
  function hideOverlay(el) {
    el.style.transition = 'opacity 0.6s ease';
    el.style.opacity    = '0';
    setTimeout(function () { el.style.display = 'none'; }, 650);
  }

  /**
   * Kiểm tra và ẩn các overlay đến giờ.
   */
  function checkAndHideOverlays() {
    OVERLAY_SCHEDULE.forEach(function (item) {
      var el = document.querySelector(item.selector);
      if ( ! el || el.style.display === 'none' ) return;
      if ( shouldHideOverlay(item.hideHour, item.hideMin) ) {
        hideOverlay(el);
      }
    });
  }

  /**
   * Kiểm tra hiện tại có đang trong khung giờ live không.
   */
  function isLiveWindow() {
    const h = new Date().getHours();
    return h >= LIVE_START && h < LIVE_END;
  }

  /**
   * Format giờ:phút:giây
   */
  function timeNow() {
    const d = new Date();
    return [
      String(d.getHours()).padStart(2, '0'),
      String(d.getMinutes()).padStart(2, '0'),
      String(d.getSeconds()).padStart(2, '0'),
    ].join(':');
  }

  /**
   * Reload toàn bộ trang live bằng cách thay thế nội dung qua AJAX.
   * Điều này giữ nguyên scroll position.
   */
  function reloadPage() {
    const url = window.location.href.split('?')[0] + '?_live_refresh=' + Date.now();

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Parse HTML response
        const parser = new DOMParser();
        const doc    = parser.parseFromString(html, 'text/html');

        // Cập nhật main content
        const newMain  = doc.getElementById('kqxs-live-page');
        const currMain = document.getElementById('kqxs-live-page');
        if (newMain && currMain) {
          // Giữ lại scroll position
          const scrollY = window.scrollY;
          currMain.innerHTML = newMain.innerHTML;
          window.scrollTo(0, scrollY);

          // Thông báo cho _rolling_number.js biết DOM đã được thay mới
          document.dispatchEvent(new CustomEvent('kqxs-live-refreshed'));
        }

        // Cập nhật thời gian refresh trong banner
        updateRefreshBadge();

        // Sau khi reload, kiểm tra lại overlay ngay
        checkAndHideOverlays();
      })
      .catch(function (err) {
        console.warn('[kqxs-live] refresh failed:', err);
      });
  }

  /**
   * Cập nhật label "Cập nhật lúc HH:MM:SS" trong các block live.
   */
  function updateRefreshBadge() {
    document.querySelectorAll('[data-kqxs-live-time]').forEach(function (el) {
      el.textContent = 'Cập nhật lúc ' + timeNow();
    });
  }

  /**
   * Khởi tạo countdown trong banner live.
   */
  function initCountdown(banner, intervalSec) {
    if (!banner) return;

    let remaining = intervalSec;
    const counterEl = document.createElement('span');
    counterEl.style.cssText = 'font-size:0.8rem;opacity:0.8;margin-left:8px;';
    banner.appendChild(counterEl);

    function tick() {
      if (remaining <= 0) {
        counterEl.textContent = 'Đang tải...';
        return;
      }
      counterEl.textContent = '(refresh sau ' + remaining + 's)';
      remaining--;
    }

    tick();
    return setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Kiểm tra và ẩn overlay ngay khi DOM sẵn sàng
    checkAndHideOverlays();

    // Poll mỗi 30 giây để ẩn overlay đúng giờ (phòng trang được mở sẵn)
    setInterval(checkAndHideOverlays, 30 * 1000);

    const config = document.getElementById('kqxs-live-config');
    if (!config) return;

    const isLive  = config.dataset.isLive === '1';
    const banner  = document.querySelector('.live-page__banner');
    const refreshBtn = document.getElementById('kqxs-live-refresh');

    // Nút refresh ngay
    if (refreshBtn) {
      refreshBtn.addEventListener('click', function (e) {
        e.preventDefault();
        reloadPage();
      });
    }

    // Auto-refresh chỉ trong giờ live
    if (!isLive && !isLiveWindow()) return;

    let countdownTimer = initCountdown(banner, REFRESH_INTERVAL_S);

    // Auto-refresh mỗi 30 giây
    const refreshTimer = setInterval(function () {
      if (!isLiveWindow()) {
        // Thoát khỏi giờ live → dừng timer
        clearInterval(refreshTimer);
        if (countdownTimer) clearInterval(countdownTimer);
        if (banner) {
          banner.innerHTML = '<span>⏸ Đã kết thúc phát sóng trực tiếp hôm nay.</span>';
        }
        return;
      }

      // Reload và reset countdown
      reloadPage();
      if (countdownTimer) clearInterval(countdownTimer);
      countdownTimer = initCountdown(banner, REFRESH_INTERVAL_S);
    }, REFRESH_INTERVAL_S * 1000);

    // Cập nhật trạng thái badge theo giờ mỗi phút
    setInterval(updateStatusBadges, 60 * 1000);
  });

  /**
   * Cập nhật trạng thái badge (waiting/opening/completed) dựa trên giờ hiện tại.
   */
  function updateStatusBadges() {
    const h = new Date().getHours();

    // Map province → cutoff
    const cutoffs = { mina: 16, mitr: 17, miba: 18 };

    document.querySelectorAll('.live-status[data-province]').forEach(function (el) {
      const province = el.dataset.province;
      const cutoff   = cutoffs[province] || 16;

      let status, label;
      if (h < cutoff - 1) {
        status = 'live-status--waiting';
        label  = '⏳ Chờ xổ';
      } else if (h < cutoff) {
        status = 'live-status--opening';
        label  = '🔴 Đang xổ';
      } else {
        status = 'live-status--completed';
        label  = '✅ Đã có KQ';
      }

      // Xoá class cũ, thêm class mới
      el.classList.remove(
        'live-status--waiting',
        'live-status--opening',
        'live-status--new',
        'live-status--completed'
      );
      el.classList.add(status);
      el.textContent = label;
    });
  }

})();

(function () {
  'use strict';

  const LIVE_START = 16; // 16:00
  const LIVE_END   = 20; // 20:00
  const REFRESH_INTERVAL_S = 30; // giây

  /**
   * Kiểm tra hiện tại có đang trong khung giờ live không.
   */
  function isLiveWindow() {
    const h = new Date().getHours();
    return h >= LIVE_START && h < LIVE_END;
  }

  /**
   * Format giờ:phút:giây
   */
  function timeNow() {
    const d = new Date();
    return [
      String(d.getHours()).padStart(2, '0'),
      String(d.getMinutes()).padStart(2, '0'),
      String(d.getSeconds()).padStart(2, '0'),
    ].join(':');
  }

  /**
   * Reload toàn bộ trang live bằng cách thay thế nội dung qua AJAX.
   * Điều này giữ nguyên scroll position.
   */
  function reloadPage() {
    const url = window.location.href.split('?')[0] + '?_live_refresh=' + Date.now();

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Parse HTML response
        const parser = new DOMParser();
        const doc    = parser.parseFromString(html, 'text/html');

        // Cập nhật main content
        const newMain  = doc.getElementById('kqxs-live-page');
        const currMain = document.getElementById('kqxs-live-page');
        if (newMain && currMain) {
          // Giữ lại scroll position
          const scrollY = window.scrollY;
          currMain.innerHTML = newMain.innerHTML;
          window.scrollTo(0, scrollY);

          // Thông báo cho _rolling_number.js biết DOM đã được thay mới
          document.dispatchEvent(new CustomEvent('kqxs-live-refreshed'));
        }

        // Cập nhật thời gian refresh trong banner
        updateRefreshBadge();
      })
      .catch(function (err) {
        console.warn('[kqxs-live] refresh failed:', err);
      });
  }

  /**
   * Cập nhật label "Cập nhật lúc HH:MM:SS" trong các block live.
   */
  function updateRefreshBadge() {
    document.querySelectorAll('[data-kqxs-live-time]').forEach(function (el) {
      el.textContent = 'Cập nhật lúc ' + timeNow();
    });
  }

  /**
   * Khởi tạo countdown trong banner live.
   */
  function initCountdown(banner, intervalSec) {
    if (!banner) return;

    let remaining = intervalSec;
    const counterEl = document.createElement('span');
    counterEl.style.cssText = 'font-size:0.8rem;opacity:0.8;margin-left:8px;';
    banner.appendChild(counterEl);

    function tick() {
      if (remaining <= 0) {
        counterEl.textContent = 'Đang tải...';
        return;
      }
      counterEl.textContent = '(refresh sau ' + remaining + 's)';
      remaining--;
    }

    tick();
    return setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const config = document.getElementById('kqxs-live-config');
    if (!config) return;

    const isLive  = config.dataset.isLive === '1';
    const banner  = document.querySelector('.live-page__banner');
    const refreshBtn = document.getElementById('kqxs-live-refresh');

    // Nút refresh ngay
    if (refreshBtn) {
      refreshBtn.addEventListener('click', function (e) {
        e.preventDefault();
        reloadPage();
      });
    }

    // Auto-refresh chỉ trong giờ live
    if (!isLive && !isLiveWindow()) return;

    let countdownTimer = initCountdown(banner, REFRESH_INTERVAL_S);

    // Auto-refresh mỗi 30 giây
    const refreshTimer = setInterval(function () {
      if (!isLiveWindow()) {
        // Thoát khỏi giờ live → dừng timer
        clearInterval(refreshTimer);
        if (countdownTimer) clearInterval(countdownTimer);
        if (banner) {
          banner.innerHTML = '<span>⏸ Đã kết thúc phát sóng trực tiếp hôm nay.</span>';
        }
        return;
      }

      // Reload và reset countdown
      reloadPage();
      if (countdownTimer) clearInterval(countdownTimer);
      countdownTimer = initCountdown(banner, REFRESH_INTERVAL_S);
    }, REFRESH_INTERVAL_S * 1000);

    // Cập nhật trạng thái badge theo giờ mỗi phút
    setInterval(updateStatusBadges, 60 * 1000);
  });

  /**
   * Cập nhật trạng thái badge (waiting/opening/completed) dựa trên giờ hiện tại.
   */
  function updateStatusBadges() {
    const h = new Date().getHours();

    // Map province → cutoff
    const cutoffs = { mina: 17, mitr: 18, miba: 19 };

    document.querySelectorAll('.live-status[data-province]').forEach(function (el) {
      const province = el.dataset.province;
      const cutoff   = cutoffs[province] || 17;

      let status, label;
      if (h < cutoff - 1) {
        status = 'live-status--waiting';
        label  = '⏳ Chờ xổ';
      } else if (h < cutoff) {
        status = 'live-status--opening';
        label  = '🔴 Đang xổ';
      } else {
        status = 'live-status--completed';
        label  = '✅ Đã có KQ';
      }

      // Xoá class cũ, thêm class mới
      el.classList.remove(
        'live-status--waiting',
        'live-status--opening',
        'live-status--new',
        'live-status--completed'
      );
      el.classList.add(status);
      el.textContent = label;
    });
  }

})();
